'use client';

import { LazyMotion } from 'framer-motion';

// Load animation features as a separate async chunk — keeps domAnimation out of the initial bundle.
const loadFeatures = () => import('./motionFeatures').then(m => m.default);

export default function MotionProvider({ children }: { children: React.ReactNode }) {
  return <LazyMotion features={loadFeatures}>{children}</LazyMotion>;
}
